import { render, staticRenderFns } from "./OtherReceiptPaymentForm.vue?vue&type=template&id=0c37f9b9"
import script from "./OtherReceiptPaymentForm.vue?vue&type=script&lang=js"
export * from "./OtherReceiptPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports